<template>
  <!-- Filters -->
  <b-row class="filters">
    <b-col>
      <!-- Select organizations manually {{selectOrganizationsManually}} -->
      <b-tabs
        v-model="tabIndex"
        card
        class="filter-icons green-switch"
        active-nav-item-class="tab-content"
        nav-wrapper-class="tab-header"
        active-tab-class="tab-content"
        nav-class="tab-header"
        content-class="tab-content"
      >
        <!--OrganizationFilter -->
        <b-tab>
          <template slot="title">
            <span
              :class="{
                'enabled-filter': !organizationFilterSelected,
                'selected-filter': organizationFilterSelected,
              }"
              ><i class="icon icon-organization_filter_icon" />
              {{ $t("label_advancedData_mainFilterBar_organization") }}</span
            >
          </template>
          <b-row>
            <b-col align="center">
              <div>
                <div>
                  <b-row>
                    <b-col :md="4" offset="4">
                      <b-form-checkbox
                        v-model="selectOrganizationsManually"
                        name="check-button"
                        switch
                        size="lg"
                      >
                        {{ $t("label_advancedData_selectManually") }}
                      </b-form-checkbox>
                    </b-col>
                    <b-col :md="4">
                      <span
                        class="template-actions"
                        @click="selectAllOrganizationFilters()"
                      >
                        {{ $t("label_advancedData_checkAll") }}</span
                      >
                      <span
                        class="ml-4 template-actions"
                        @click="unselectAllOrganizationFilters()"
                      >
                        {{ $t("label_advancedData_uncheckAll") }}</span
                      >
                    </b-col>
                  </b-row>
                </div>
                <b-form-group v-if="selectOrganizationsManually">
                  <b-form-checkbox-group
                    id="organizations-checkbox-group"
                    v-model="selectedOrganizations"
                    name="checkbox-group"
                  >
                    <b-form-checkbox
                      v-for="organization in organizations"
                      :key="organization.id"
                      v-model="selectedOrganizations"
                      :value="organization"
                    >
                      {{ organization.general_business_companyName }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <div v-else>
                  <p>
                    {{
                      $t(
                        "label_advancedData_compare_warningMessage_allOrganizationSelectedByDefault"
                      )
                    }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <!-- End Organization Filter-->

        <!--Year Filter -->
        <b-tab>
          <template slot="title">
            <span
              class="enabled-filter"
              :class="{ 'selected-filter': isYearFilterSelected() }"
              ><i class="icon icon-year_filter_icon" />
              {{ $t("label_advancedData_mainFilterBar_year") }}</span
            >
          </template>
          <b-row v-if="!multipleYears">
            <b-col offset="2">
              <b-form-group
                id="advancedData_mainFilterBar_year"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="advancedData_mainFilterBar_year"
              >
                <template slot="label">
                  {{ $t("label_advancedData_mainFilterBar_year") }}
                  <template-tooltip
                    tooltip="label_advancedData_mainFilterBar_year_tooltip"
                  />
                </template>
                <b-form-select
                  id="advancedData_mainFilterBar_year"
                  v-model="advancedData_mainFilterBar_year"
                  class="mb-3"
                  :disabled="!yearEnabled"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="string" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(year, indexYear) in years"
                    :key="indexYear"
                    :value="year"
                  >
                    {{ $t(year) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3" align="left">
              <b-form-checkbox
                v-model="yearEnabled"
                name="check-button"
                switch
                size="lg"
              />
            </b-col>
          </b-row>
          <b-row v-if="multipleYears">
            <b-col align="center">
              <div>
                <div>
                  <b-row>
                    <b-col :md="4" offset="4">
                      <b-form-checkbox
                        v-model="selectYearsManually"
                        name="check-button"
                        switch
                        size="lg"
                      >
                        {{ $t("label_advancedData_selectManually") }}
                      </b-form-checkbox>
                    </b-col>
                    <b-col :md="4">
                      <a
                        class="template-actions"
                        href="javascript:void()"
                        @click="selectAllYearsFilters()"
                      >
                        {{ $t("label_advancedData_checkAll") }}</a
                      >
                      <a
                        class="ml-4 template-actions"
                        href="javascript:void()"
                        @click="unselectAllYearsFilters()"
                      >
                        {{ $t("label_advancedData_uncheckAll") }}</a
                      >
                    </b-col>
                  </b-row>
                </div>
                <b-form-group v-if="selectYearsManually">
                  <b-form-checkbox-group
                    id="organizations-checkbox-group"
                    v-model="selectedYearFilter"
                    name="checkbox-group"
                  >
                    <b-form-checkbox
                      v-for="year in years"
                      :key="year"
                      v-model="selectedYearFilter"
                      :value="year"
                    >
                      {{ year }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <div v-else>
                  <p>
                    {{
                      $t(
                        "label_advancedData_compare_warningMessage_allOrganizationSelectedByDefault"
                      )
                    }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <!-- End Year Filter-->

        <!--Tag Filter -->
        <b-tab>
          <template slot="title">
            <span
              :class="{
                'enabled-filter': !selectOrganizationsManually,
                'selected-filter': tagFilterSelected(),
                'disabled-filter': selectOrganizationsManually,
              }"
              ><i class="icon icon-tag_filter_icon" />
              {{ $t("label_advancedData_mainFilterBar_tag") }}</span
            >
          </template>
          <b-row>
            <b-col align="center">
              <div v-if="selectOrganizationsManually" class="disabled-filter">
                <p>
                  {{
                    $t(
                      "label_advancedData_compare_warningMessage_deactivateManualSelection"
                    )
                  }}
                </p>
              </div>
              <b-form-group v-if="!selectOrganizationsManually">
                <b-row>
                  <b-col :md="4" offset="4">
                    <b-form-checkbox
                      v-model="selectTagsManually"
                      name="check-button"
                      switch
                      size="lg"
                    >
                      {{ $t("label_advancedData_selectManually") }}
                    </b-form-checkbox>
                  </b-col>
                  <b-col :md="4">
                    <span
                      class="template-actions"
                      @click="selectAllTagsFilter()"
                    >
                      {{ $t("label_advancedData_checkAll") }}</span
                    >
                    <span
                      class="ml-4 template-actions"
                      @click="unselectAllTags()"
                    >
                      {{ $t("label_advancedData_uncheckAll") }}</span
                    >
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                v-if="selectTagsManually && !selectOrganizationsManually"
              >
                <b-form-checkbox-group
                  id="tags-checkbox-group"
                  v-model="selectedTags"
                  name="tags"
                >
                  <b-form-checkbox
                    v-for="tag in tags"
                    :key="tag.id"
                    v-model="selectedTags"
                    :value="tag"
                  >
                    {{ tag.name }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
              <div v-else>
                {{
                  $t(
                    "label_advancedData_compare_warningMessage_allTagsSelectedByDefault"
                  )
                }}
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <!-- End Tag Filter-->

        <!--Location Filter -->
        <b-tab>
          <template slot="title">
            <span
              :class="{
                'selected-filter': isLocationFilterSelected(),
                'enabled-filter': !selectOrganizationsManually,
                'disabled-filter': selectOrganizationsManually,
              }"
              ><i class="icon icon-location_filter_icon" />
              {{ $t("label_advancedData_mainFilterBar_location") }}</span
            >
          </template>
          <b-row>
            <b-col align="center">
              <div v-if="selectOrganizationsManually" class="disabled-filter">
                <p>
                  {{
                    $t(
                      "label_advancedData_compare_warningMessage_deactivateManualSelection"
                    )
                  }}
                </p>
              </div>
              <div v-else>
                <b-row>
                  <b-col offset="2">
                    <b-form-group
                      id="selfAssessment_general_business_locationCountry_id"
                      horizontal
                      label-class="text-sm-right"
                      label-cols="5"
                      label-for="selfAssessment_general_business_locationCountry_id"
                    >
                      <template slot="label">
                        {{
                          $t(
                            "label_selfAssessment_general_business_locationCountry"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_general_business_locationCountry_tooltip"
                        />
                      </template>
                      <b-form-select
                        id="selfAssessment_general_business_locationCountry_id"
                        v-model="
                          selfAssessment_general_business_locationCountry_id
                        "
                        class="mb-3"
                        :disabled="!locationEnabled"
                      >
                        <template slot="first">
                          <!-- this slot appears above the options from 'options' prop -->
                          <option value="string" disabled>
                            {{ $t("label_selfAssessment_optionList_default") }}
                          </option>
                        </template>
                        <option
                          v-for="(item, itemKey) in locations"
                          :key="itemKey"
                          :value="item"
                        >
                          {{ $t(item) }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" align="left">
                    <b-form-checkbox
                      v-model="locationEnabled"
                      name="check-button"
                      switch
                      size="lg"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <!-- End Location Filter-->

        <!--Activity Filter -->
        <b-tab>
          <template slot="title">
            <span
              :class="{
                'selected-filter': isActivityFilterSelected(),
                'enabled-filter': !selectOrganizationsManually,
                'disabled-filter': selectOrganizationsManually,
              }"
              ><i class="icon icon-activity_filter_icon" />
              {{ $t("label_advancedData_mainFilterBar_activity") }}</span
            >
          </template>
          <b-row>
            <b-col align="center">
              <div v-if="selectOrganizationsManually" class="disabled-filter">
                <p>
                  {{
                    $t(
                      "label_advancedData_compare_warningMessage_deactivateManualSelection"
                    )
                  }}
                </p>
              </div>
              <div v-else>
                <!-- economicSector -->
                <b-row>
                  <b-col offset="2">
                    <b-form-group
                      id="selfAssessment_general_classification_sector"
                      horizontal
                      label-class="text-sm-right"
                      label-cols="5"
                      :label="
                        $t('label_selfAssessment_general_classification_sector')
                      "
                      label-for="selfAssessment_general_classification_sector"
                    >
                      <b-form-select
                        id="selfAssessment_general_classification_sector"
                        v-model="selfAssessment_general_classification_sector"
                        class="mb-3"
                        :disabled="!economicSectorEnabled"
                      >
                        <template slot="first">
                          <!-- this slot appears above the options from 'options' prop -->
                          <option value="" disabled>
                            {{ $t("label_selfAssessment_optionList_default") }}
                          </option>
                        </template>
                        <option
                          v-for="(item, itemKey) in getOptionListByName(
                            'optionList_selfAssessment_general_classification_sector'
                          )"
                          :key="itemKey"
                          :value="item.name"
                        >
                          {{ $t(item.name) }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" align="left">
                    <b-form-checkbox
                      v-model="economicSectorEnabled"
                      name="check-button"
                      switch
                      size="lg"
                    />
                  </b-col>
                </b-row>
                <!-- end EconomicSector -->

                <!-- aggregatedActivity -->
                <b-row>
                  <b-col offset="2">
                    <b-form-group
                      id="selfAssessment_general_classification_activityAggregated"
                      horizontal
                      label-class="text-sm-right"
                      label-cols="5"
                      :label="
                        $t(
                          'label_selfAssessment_general_classification_activityAggregated'
                        )
                      "
                      label-for="selfAssessment_general_classification_activityAggregated"
                    >
                      <b-form-select
                        id="selfAssessment_general_classification_activityAggregated"
                        v-model="
                          selfAssessment_general_classification_activityAggregated
                        "
                        class="mb-3"
                        :disabled="!aggregatedEconomicActivityEnabled"
                      >
                        <template slot="first">
                          <!-- this slot appears above the options from 'options' prop -->
                          <option value="" disabled>
                            {{ $t("label_selfAssessment_optionList_default") }}
                          </option>
                        </template>
                        <option
                          v-for="(item, itemKey) in getOptionListByName(
                            'optionList_selfAssessment_general_classification_activityAggregated'
                          )"
                          :key="itemKey"
                          :value="item.name"
                        >
                          {{ $t(item.name) }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" align="left">
                    <b-form-checkbox
                      v-model="aggregatedEconomicActivityEnabled"
                      name="check-button"
                      switch
                      size="lg"
                    />
                  </b-col>
                </b-row>
                <!-- end aggregatedActivity -->

                <!-- detailedEconomicActivity -->
                <b-row>
                  <b-col offset="2">
                    <b-form-group
                      id="selfAssessment_general_classification_activityDetailed"
                      horizontal
                      label-class="text-sm-right"
                      label-cols="5"
                      :label="
                        $t(
                          'label_selfAssessment_general_classification_activityDetailed'
                        )
                      "
                      label-for="selfAssessment_general_classification_activityDetailed"
                    >
                      <b-form-select
                        id="selfAssessment_general_classification_activityDetailed"
                        v-model="
                          selfAssessment_general_classification_activityDetailed
                        "
                        class="mb-3"
                        :disabled="!activityDetailedEnabled"
                      >
                        <template slot="first">
                          <!-- this slot appears above the options from 'options' prop -->
                          <option value="" disabled>
                            {{ $t("label_selfAssessment_optionList_default") }}
                          </option>
                        </template>
                        <option
                          v-for="(item, itemKey) in getOptionListByName(
                            'optionList_selfAssessment_general_classification_activityDetailed'
                          )"
                          :key="itemKey"
                          :value="item.name"
                        >
                          {{ $t(item.name) }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" align="left">
                    <b-form-checkbox
                      v-model="activityDetailedEnabled"
                      name="check-button"
                      switch
                      size="lg"
                    />
                  </b-col>
                </b-row>
                <!-- end detailedEconomicActivity -->

                <!-- tagetMarket V-MODEL NEEDS TO BE ADJUSTED-->
                <b-row>
                  <b-col offset="2">
                    <div
                      id="label_selfAssessment_general_classification_market"
                    >
                      <div class="form-row">
                        <label class="col-sm-5 col-form-label text-sm-right"
                          >{{
                            $t(
                              "label_selfAssessment_general_classification_market"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_general_classification_market_tooltip"
                          />
                        </label>
                        <div class="col">
                          <label class="custom-control custom-checkbox">
                            <input
                              id="selfAssessment_general_classification_market_international"
                              v-model="
                                selfAssessment_general_classification_market_international
                              "
                              type="checkbox"
                              :true-value="true"
                              :false-value="false"
                              :disabled="!targetedMarketEnabled"
                            />
                            <span class="custom-control-description">{{
                              $t(
                                "selfAssessment_general_classification_market_international"
                              )
                            }}</span>
                          </label>

                          <label class="custom-control custom-checkbox">
                            <input
                              id="selfAssessment_general_classification_market_national"
                              v-model="
                                selfAssessment_general_classification_market_national
                              "
                              type="checkbox"
                              :true-value="true"
                              :false-value="false"
                              :disabled="!targetedMarketEnabled"
                            />
                            <span class="custom-control-description">{{
                              $t(
                                "selfAssessment_general_classification_market_national"
                              )
                            }}</span>
                          </label>
                          <label class="custom-control custom-checkbox">
                            <input
                              id="selfAssessment_general_classification_market_local"
                              v-model="
                                selfAssessment_general_classification_market_local
                              "
                              type="checkbox"
                              :true-value="true"
                              :false-value="false"
                              :disabled="!targetedMarketEnabled"
                            />
                            <span class="custom-control-description">{{
                              $t(
                                "selfAssessment_general_classification_market_local"
                              )
                            }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col sm="3" align="left">
                    <b-form-checkbox
                      v-model="targetedMarketEnabled"
                      name="check-button"
                      switch
                      size="lg"
                    />
                  </b-col>
                </b-row>
                <!-- end tagetMarket -->
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <!-- End Activity Filter-->

        <!--Size Filter -->
        <b-tab>
          <template slot="title">
            <span
              :class="{
                'selected-filter': isSizeFilterSelected(),
                'enabled-filter': !selectOrganizationsManually,
                'disabled-filter': selectOrganizationsManually,
              }"
              ><i class="icon icon-size_filter_icon" />
              {{ $t("label_advancedData_mainFilterBar_size") }}</span
            >
          </template>
          <b-row>
            <b-col align="center">
              <div v-if="selectOrganizationsManually" class="disabled-filter">
                <p>
                  {{
                    $t(
                      "label_advancedData_compare_warningMessage_deactivateManualSelection"
                    )
                  }}
                </p>
              </div>
              <div v-else>
                <b-row>
                  <b-col offset="2">
                    <b-form-group
                      id="selfAssessment_general_size_numberEmployees"
                      horizontal
                      label-class="text-sm-right"
                      label-cols="5"
                      :label="
                        $t('label_selfAssessment_general_size_numberEmployees')
                      "
                      label-for="selfAssessment_general_size_numberEmployees"
                    >
                      <b-form-select
                        id="selfAssessment_general_size_numberEmployees"
                        v-model="selfAssessment_general_size_numberEmployees"
                        class="mb-3"
                        :disabled="!numberOfEmployeesEnabled"
                      >
                        <template slot="first">
                          <!-- this slot appears above the options from 'options' prop -->
                          <option value="" disabled>
                            {{ $t("label_selfAssessment_optionList_default") }}
                          </option>
                        </template>
                        <option
                          v-for="(item, itemKey) in getOptionListByName(
                            'optionList_selfAssessment_general_size_numberEmployees'
                          )"
                          :key="itemKey"
                          :value="item.name"
                        >
                          {{ $t(item.name) }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" align="left">
                    <b-form-checkbox
                      v-model="numberOfEmployeesEnabled"
                      name="check-button"
                      switch
                      size="lg"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col offset="2">
                    <b-form-group
                      id="selfAssessment_general_size_revenue"
                      horizontal
                      label-class="text-sm-right"
                      label-cols="5"
                      :label="$t('label_selfAssessment_general_size_revenue')"
                      label-for="selfAssessment_general_size_revenue"
                    >
                      <b-form-select
                        id="selfAssessment_general_size_revenue"
                        v-model="selfAssessment_general_size_revenue"
                        class="mb-3"
                        :disabled="!anualRevenueEnabled"
                      >
                        <template slot="first">
                          <!-- this slot appears above the options from 'options' prop -->
                          <option value="" disabled>
                            {{ $t("label_selfAssessment_optionList_default") }}
                          </option>
                        </template>
                        <option
                          v-for="(item, itemKey) in getOptionListByName(
                            'optionList_selfAssessment_general_size_revenue'
                          )"
                          :key="itemKey"
                          :value="item.name"
                        >
                          {{ $t(item.name) }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" align="left">
                    <b-form-checkbox
                      v-model="anualRevenueEnabled"
                      name="check-button"
                      switch
                      size="lg"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <!-- End Size Filter-->

        <!--Type Filter -->
        <b-tab>
          <template slot="title">
            <span
              :class="{
                'selected-filter': isTypeFilterSelected(),
                'enabled-filter': !selectOrganizationsManually,
                'disabled-filter': selectOrganizationsManually,
              }"
              ><i class="icon icon-type_filter_icon" />
              {{ $t("label_advancedData_mainFilterBar_type") }}</span
            >
          </template>
          <b-row>
            <b-col align="center">
              <div v-if="selectOrganizationsManually" class="disabled-filter">
                <p>
                  {{
                    $t(
                      "label_advancedData_compare_warningMessage_deactivateManualSelection"
                    )
                  }}
                </p>
              </div>
              <div v-else>
                <b-row>
                  <b-col offset="2">
                    <b-form-group
                      id="selfAssessment_general_business_organizationType"
                      horizontal
                      label-class="text-sm-right"
                      label-cols="5"
                      label-for="selfAssessment_general_business_organizationType"
                    >
                      <template slot="label">
                        {{
                          $t(
                            "label_selfAssessment_general_business_organizationType"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_general_business_organizationType_tooltip"
                        />
                      </template>
                      <b-form-select
                        id="selfAssessment_general_business_organizationType"
                        v-model="
                          selfAssessment_general_business_organizationType
                        "
                        class="mb-3"
                        :disabled="!organizationTypeEnabled"
                      >
                        <template slot="first">
                          <!-- this slot appears above the options from 'options' prop -->
                          <option value="string" disabled>
                            {{ $t("label_selfAssessment_optionList_default") }}
                          </option>
                        </template>
                        <option
                          v-for="(item, itemKey) in getOptionListByName(
                            'optionList_selfAssessment_general_business_organizationType'
                          )"
                          :key="itemKey"
                          :value="item.name"
                        >
                          {{ $t(item.name) }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" align="left">
                    <b-form-checkbox
                      v-model="organizationTypeEnabled"
                      name="check-button"
                      switch
                      size="lg"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <!-- End Type Filter-->
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { mapGetters } from "vuex";
const { mapFields } = createHelpers({
  getterType: "getAdvancedDataField",
  mutationType: "updateAdvancedDataField",
});

const SIZE_FILTERS = [
  {
    toggle: "numberOfEmployeesEnabled",
    field: "selfAssessment_general_size_numberEmployees",
  },
  {
    toggle: "anualRevenueEnabled",
    field: "selfAssessment_general_size_revenue",
  },
];

const ACTIVITY_FILTERS = [
  {
    toggle: "economicSectorEnabled",
    field: "selfAssessment_general_classification_sector",
  },
  {
    toggle: "aggregatedEconomicActivityEnabled",
    field: "selfAssessment_general_classification_activityAggregated",
  },
  {
    toggle: "activityDetailedEnabled",
    field: "selfAssessment_general_classification_activityDetailed",
  },
  {
    toggle: "targetedMarketEnabled",
    field: "selfAssessment_general_classification_market_international",
  },
  {
    toggle: "targetedMarketEnabled",
    field: "selfAssessment_general_classification_market_national",
  },
  {
    toggle: "targetedMarketEnabled",
    field: "selfAssessment_general_classification_market_local",
  },
];

export default {
  name: "Filters",
  props: {
    alias: {
      type: String,
      default: "",
    },
    multipleYears: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {

      comparativeData: {
        generalIndex: [],
        pillars: {},
      },
      locationFilterSelected: false,
      activityFilterSelected: false,
      sizeFilterSelected: false,
      typeFilterSelected: false,
      selectedActivities: [],
      organizations: [],
      locations: [],
      tags: [
        { text: "tag1", value: "tag1" },
        { text: "tag2", value: "tag2" },
      ],
      activities: [],
      years: [],
    };
  },
  computed: {
    organizationFilterSelected: function () {
      if (
        this.selectOrganizationsManually &&
        this.selectedOrganizations &&
        this.selectedOrganizations.length > 0
      ) {
        return true;
      }
      return false;
    },
    yearFilterSelected: function () {
      /*
      if (this.yearFilterSelected) {
        return true
      }
      */
      return false;
    },
    ...mapGetters({
      getOptionListByName: "getOptionListByName",
      getYears: "getYears",
      getSelectedFilters: "getSelectedFilters",
    }),
    ...mapFields([
      "tabIndex",
      "selectOrganizationsManually",
      "selectYearsManually",
      "selectTagsManually",
      "advancedData_mainFilterBar_year",
      "selectedYearFilter",
      "selfAssessment_general_business_locationCountry_id",
      "selfAssessment_general_classification_sector",
      "selfAssessment_general_classification_activityAggregated",
      "selfAssessment_general_classification_activityDetailed",
      "selfAssessment_general_classification_market_international",
      "selfAssessment_general_classification_market_local",
      "selfAssessment_general_classification_market_national",
      "selfAssessment_general_size_numberEmployees",
      "selfAssessment_general_size_revenue",
      "selfAssessment_general_business_organizationType",
      "yearEnabled",
      "locationEnabled",
      "economicSectorEnabled",
      "aggregatedEconomicActivityEnabled",
      "activityDetailedEnabled",
      "targetedMarketEnabled",
      "numberOfEmployeesEnabled",
      "anualRevenueEnabled",
      "organizationTypeEnabled",
      "selectedOrganizations",
      "selectedTags",
    ]),
  },
  created() {
    this.setComparativeFiltersFromPromise();
    var check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
          a.substr(0, 4)
        )
      ) {
        check = true;
      }
    })(navigator.userAgent || navigator.vendor || window.opera);

    this.isMobile = check;
  },
  methods: {
    isActivityFilterSelected: function () {
      return this.anyCheckboxIsSelected(ACTIVITY_FILTERS);
    },
    tagFilterSelected: function () {
      if (!this.selectTagsManually) {
        return false;
      }

      if (
        !this.selectOrganizationsManually &&
        this.selectedTags &&
        this.selectedTags.length > 0
      ) {
        return true;
      }
      return false;
    },
    isLocationFilterSelected: function () {
      return this.checkboxFilterSelected(
        "locationEnabled",
        "selfAssessment_general_business_locationCountry_id"
      );
    },
    isTypeFilterSelected: function () {
      return this.checkboxFilterSelected(
        "organizationTypeEnabled",
        "selfAssessment_general_business_organizationType"
      );
    },
    isYearFilterSelected: function () {
      if (
        (this.advancedData_mainFilterBar_year && this.yearEnabled) ||
        (this.selectYearsManually && this.selectedYearFilter.length)
      ) {
        return true;
      }
      return false;
    },
    isSizeFilterSelected: function () {
      return this.anyCheckboxIsSelected(SIZE_FILTERS);
    },
    checkboxFilterSelected: function (toggleName, fieldName) {
      if (
        !this.selectOrganizationsManually &&
        this[fieldName] &&
        this[toggleName]
      ) {
        return true;
      }
      return false;
    },
    anyCheckboxIsSelected: function (checkboxToggleArray) {
      for (const selectCheckboxObject of checkboxToggleArray) {
        if (
          this.checkboxFilterSelected(
            selectCheckboxObject.toggle,
            selectCheckboxObject.field
          )
        ) {
          return true;
        }
      }
      return false;
    },
    getOrganizationsSelectedData: function () {
      if (!this.organizationFilterSelected) {
        return [];
      }
      return this.selectedOrganizations.map((organization) => {
        return organization.id;
      });
    },
    getTagsSelectedData: function () {
      if (!this.tagFilterSelected()) {
        return [];
      }
      return this.getOrganizationExcludedSelectedFilters("selectedTags").map(
        (organization) => {
          return organization.id;
        }
      );
    },
    getTypeSelectedData: function () {
      if (!this.isTypeFilterSelected()) {
        return [];
      }
      return [this.selfAssessment_general_business_organizationType];
    },
    getYearData: function () {
      if (!this.isYearFilterSelected()) {
        return [];
      }
      return this.multipleYears
        ? this.selectedYearFilter
        : [this.advancedData_mainFilterBar_year];
    },
    getLocationData: function () {
      if (!this.isLocationFilterSelected()) {
        return [];
      }
      return [this.selfAssessment_general_business_locationCountry_id];
    },
    getSizeData: function () {
      if (!this.isSizeFilterSelected()) {
        return [];
      }
      return this.getSectionFiltersInformation(SIZE_FILTERS);
    },
    getActivitiesData: function () {
      if (!this.isActivityFilterSelected()) {
        return [];
      }
      return this.getSectionFiltersInformation(ACTIVITY_FILTERS);
    },
    getOrganizationExcludedSelectedFilters: function (
      selectedObjectDescription
    ) {
      const ORGANIZATION_EXCLUDED_FILTERS = ["selectedTags"];
      if (
        this.selectOrganizationsManually ||
        !ORGANIZATION_EXCLUDED_FILTERS.includes(selectedObjectDescription)
      ) {
        return [];
      }
      return this[selectedObjectDescription];
    },

    getGeneralIndexData() {
      return {
        generalIndex: this.comparativeData.generalIndex,
      };
    },
    getDataInFilters() {
      const parameters = {
        Companies: this.getOrganizationsSelectedData(),
        Tags: this.getTagsSelectedData(),
        Years: this.getYearData(),
        Types: this.getTypeSelectedData(),
        Locations: this.getLocationData(),
        Sizes: this.getSizeData(),
        Activities: this.getActivitiesData(),
        multipleYears: this.multipleYears,
      };
      return parameters;
    },
    setComparativeFiltersFromPromise: function () {
      this.getComparativeFilters().then((comparativeFilters) => {
        this.organizations = comparativeFilters.Companies;
        this.organizations.sort((a, b) => {
          if (a.general_business_companyName > b.general_business_companyName) {
            return 1;
          }
          if (b.general_business_companyName > a.general_business_companyName) {
            return -1;
          }
          return 0;
        });
        this.locations = comparativeFilters.Locations;
        this.tags = comparativeFilters.Tags;
        this.years = comparativeFilters.Years;
      });
    },
    getComparativeFilters() {
      return this.$store.dispatch("COMPAREPILLARS_REPORT_FILTERS");
    },
    getSectionFiltersInformation: function (sectionFilters) {
      const sectionFiltersArray = [];
      for (const filter of sectionFilters) {
        if (this[filter["toggle"]] && this[filter["field"]]) {
          const objectToAdd = {};
          objectToAdd[filter["field"]] = this[filter["field"]];
          sectionFiltersArray.push(objectToAdd);
        }
      }
      return sectionFiltersArray;
    },
    selectAllOrganizationFilters: function () {
      this.selectedOrganizations = [];
      this.organizations.forEach((organization) => {
        this.selectedOrganizations.push(organization);
      });
    },
    unselectAllOrganizationFilters: function () {
      this.selectedOrganizations = [];
    },
    selectAllYearsFilters: function () {
      this.selectedYearFilter = [];
      this.years.forEach((year) => {
        this.selectedYearFilter.push(year);
      });
    },
    unselectAllYearsFilters: function () {
      this.selectedYearFilter = [];
    },
    selectAllTagsFilter: function () {
      this.selectedTags = [];
      this.tags.forEach((tag) => {
        this.selectedTags.push(tag);
      });
    },
    unselectAllTags: function () {
      this.selectedTags = [];
    },
    clearFilters: function () {
      this.unselectAllOrganizationFilters();
      this.unselectAllTags();
      this.selectOrganizationsManually = false;
      this.yearEnabled = false;
      this.selectTagsManually = false;
      this.locationEnabled = false;
      this.economicSectorEnabled = false;
      this.activityDetailedEnabled = false;
      this.aggregatedEconomicActivityEnabled = false;
      this.targetedMarketEnabled = false;
      this.numberOfEmployeesEnabled = false;
      this.anualRevenueEnabled = false;
      this.organizationTypeEnabled = false;
      this.tabIndex = 0;
      this.selectedYearFilter = [];
      this.selectYearsManually = false;
    },
  },
};
</script>

<style lang="sass">
a
  &.template-actions
    color: #676767
    text-decoration: underline

.tab-header
  background-color: #EFF3F6!important
  color: #676767!important
.filters
  .tab-content
    background-color: #DDDDDD!important
    color: #676767!important
.tab-pane
  &.card-body
    padding-top: 1.5rem
@import "../../assets/css/variables.scss"

$icons: ('organization_filter_icon','year_filter_icon','tag_filter_icon''location_filter_icon''activity_filter_icon','size_filter_icon','type_filter_icon')
.selected-filter
  .icon
    @each $icon in $icons
      &.icon-#{$icon}
        background-color: $primary-color!important

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)
  .selected-filter
    .icon
      @each $icon in $icons
        &.icon-#{$icon}:after
        content: url(/static/icons/#{$icon}_active.svg)!important
        width: 20px!important
        height: 20px!important
        background-size: 20px 20px
        display: inline-block

.custom-select
    border-radius: 10px
    border: 1px solid #000

.green-switch
  .custom-control-input:checked ~ .custom-control-label::before
    background-color: $primary-color
    color: $primary-color

.filter-icons
  height: 100%
  align-items: center!important
  color: $enabled-filter-color
  span
    cursor: pointer
  .icon
    height: 1.2rem
    width: 1.2rem
    position: relative
    top: 2px
    color: $enabled-filter-color
    background-color: $enabled-filter-color
    margin: 0px
  .disabled-filter
    color: $disabled-filter-color
  .enabled-filter
    color: $enabled-filter-color
  .selected-filter
    color: $primary-color
    .icon
      background-color: $primary-color
</style>
